import { render, staticRenderFns } from "./WinDialogNew.vue?vue&type=template&id=1a2d39aa&scoped=true"
import script from "./WinDialogNew.vue?vue&type=script&lang=js"
export * from "./WinDialogNew.vue?vue&type=script&lang=js"
import style0 from "./WinDialogNew.vue?vue&type=style&index=0&id=1a2d39aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d39aa",
  null
  
)

export default component.exports